export default (str?: string) => (str ? new Date(str) : new Date()) as Date
